class CarouselNavHelper {
    constructor() {

    }

    allowNextButton (index, content, qualtrixCompleted=true, sessionThreeSubmitted=true, sessionFourSubmitted=true) {
        if (content) {
            const isScrollable = content.scrollHeight > content.clientHeight;
            const isBottomReached = content.scrollTop + content.clientHeight >= content.scrollHeight - 10;
    
            // console.log(`index: ${index}, extraTerms: ${extraTerms}, qualtrixCompleted: ${qualtrixCompleted}, sessionThreeSubmitted: ${sessionThreeSubmitted}, sessionThreeSubmitted: ${sessionThreeSubmitted}`);

            if(index === 1){
                return ((!isScrollable || isBottomReached) && qualtrixCompleted)
                && ((!isScrollable || isBottomReached) && sessionThreeSubmitted);
            } else {
                return !isScrollable || isBottomReached;
            }

        }
        return false;
    };
}

export default CarouselNavHelper;